import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Button from 'components/theme/Button'
import { stepperDecrease } from 'actions/view'
import { Hidden, IconButton } from '@material-ui/core'
import { ArrowBackIos, Clear } from '@material-ui/icons'
import { toggleTaskModal } from 'actions/campaign/addOrEdit'

const CancelButton = ({
  history,
  stepper,
  stepperDecrease,
  taskID,
  toggleTaskModal,
  modal,
}) => {
  const button = (size, fontSize) => {
    const back =
      size === 'small' ? (
        <ArrowBackIos style={{ position: 'absolute', left: 7 }} />
      ) : (
        'Back'
      )
    const cancel = size === 'small' ? <Clear /> : 'Cancel'

    const ButtonComponent = size === 'small' ? IconButton : Button

    const style = {
      marginTop: 3,
      border: '1px solid #014c94',
      padding: size === 'small' ? 5 : undefined,
      height: size === 'small' ? 34 : undefined,
      width: size === 'small' ? 34 : undefined,
    }

    return (
      <ButtonComponent
        size={size}
        style={fontSize ? { fontSize, ...style } : style}
        variant="outlined"
        color="secondary"
        onClick={() => {
          stepper === 0
            ? modal
              ? toggleTaskModal()
              : history.goBack()
            : stepperDecrease('task')
        }}
      >
        {stepper === 0 ? (taskID === 'new' ? cancel : back) : back}
      </ButtonComponent>
    )
  }

  return (
    <Fragment>
      <Hidden smDown>{button('medium')}</Hidden>
      <Hidden mdUp>{button('small', 8)}</Hidden>
    </Fragment>
  )
}

export default withRouter(
  connect(null, (dispatch) =>
    bindActionCreators({ stepperDecrease, toggleTaskModal }, dispatch),
  )((props) => <CancelButton {...props} />),
)
